module.exports = __webpack_public_path__ + "img/sc4.d31bd4f5.png";